import EditCurrentUser from "../../../../../../../presentation/pages/users/account/components/editCurrentUser";
import { makeChangeUserDetailsValidation } from "./edit-user-details-validation-factory";

export const makeChangeCurrentUserDetails = () => {
  return <EditCurrentUser validation={makeChangeUserDetailsValidation()} />;
};
